import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {PartitionOPEEnum} from "./PartitionOPEEnum";

class PartitionDTO {
  id!: number;
  parentId?: number;
  name!: string;
  active!: boolean;
}

class O {
  partitions!: PartitionDTO[];
}

/**
 * O Inner Class
 */
class I {

}

export class GetPartitionHierarchyCB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(PartitionOPEEnum.GetPartitionHierarchy);
    this.i = new I();
    this.o = new O();
  }
}
